import {call, put} from 'redux-saga/effects';
import {receiveServiceLevelSpecialtiesData} from "../actions/serviceLevelSpecialtiesActions";
import {fetchServiceLevelSpecialtiesData} from "../api/fetchServiceLevelSpecialtiesData";

export default function* getServiceLevelsSpecialtiesData(action) {
  try {
    const serviceLevelsSpecialtiesData = yield call(fetchServiceLevelSpecialtiesData);
    yield put(receiveServiceLevelSpecialtiesData(serviceLevelsSpecialtiesData));
  } catch (e) {
    console.log(e)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/serviceLevelSpecialtiesSaga.js